import { createFeature, createReducer, on } from '@ngrx/store';
import { setViewVisible } from './vehicle-list-view.actions';

export interface VehicleListViewState {
	viewVisible: boolean;
}

const initialState: VehicleListViewState = {
	viewVisible: false,
};

const reducer = createReducer(
	initialState,
	on(setViewVisible, (state, action) => ({ ...state, viewVisible: action.viewVisible }))
);

export const vehicleListViewFeature = createFeature({
	name: 'vehicleListView',
	reducer,
});
